import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class IndicatorsService {
  constructor(private http: HttpClient) {}

  public load(teamName: string): Observable<any> {
    return this.http.get(`${ConfigService.apiUrl}/indicators/${teamName}`);
  }
}
